import React from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import {
  StudentApplicationProcess,
  Login,
  NotAuthorized,
  UniversityApplicationProcess,
  AfterAdmit,
  Dashboard,
  Main,
} from "../pages";
import PsychoHome from "../components/admin/pagecomponent/PsychoHome.jsx";
import {
  Content,
  About,
  Table,
  Questions,
  SubmitForm,
} from "../components/admin/careerCounciling/psychometric";
import MainStudent from "../pages/student/Main";
import Application from "../components/admin/application/Application";
import RequireAuth from "./RequireAuth";
import {
  CVUpload,
  FinalDocumentUpload,
  LOR,
  ScrollToTop,
  ShortlistedTable,
  ShortListingUniversity,
  SOP,
  StatusComponent,
  UniversitySpecificSOP,
  StudentDetails,
} from "../components";
import Layout from "../Layout";
import StudentApplication from "../components/admin/pagecomponent/StudentApplication";
import Leads from "../components/admin/leads/Leads";
import Invoice from "../components/admin/invoice/Invoice";
import Customer from "../components/admin/customer/Customer";
import CustomerProfile from "../components/admin/customer/CustomerProfile";
import ServicesTabs from "../components/admin/tool/ServicesTabs";
import Home from "../components/admin/communication/Home";
import Contacts from "../components/admin/communication/contacts/Contacts";
import Communication from "../components/admin/communication/Communication";
import Campaigns from "../components/admin/communication/Campaigns";
import CareerCounciling from "../components/admin/pagecomponent/CareerCounciling";
import ProfileBuilding from "../components/admin/pagecomponent/ProfileBuilding";
import ManagePreloadedDetails from "../components/admin/careerCounciling/ManagePreloadedDetails";
import Resources from "../components/admin/resources/Resources";
import Leave from "../components/admin/pagecomponent/Leave";
import Reports from "../components/admin/communication/Reports";
import RoleAssigner from "../components/admin/tool/RoleAssigner";
import ServicingAndPricing from "../components/admin/tool/ServiceAndPricing";
import Tool from "../components/admin/tool/Tool";
import PostServices from "../components/admin/careerCounciling/PostServices";
import AuthRoute from "./AuthRoute";
import VisaProcess from "../components/student/visa_process/VisaProcess";
import { elements } from "chart.js";
import StudentResources from "../components/student/resources/StudentResources";
import Forex_cards from "../components/student/accomodation/ForexCard";
import Accomodations from "../components/student/accomodation/Accomodations";
import Accomodation from "../components/student/accomodation/MainForex.jsx";
import ForexCard from "../components/student/accomodation/ForexCard";
import LeadForm from "../components/admin/leads/LeadForm";
import ImportLeadExcel from "../components/admin/leads/ImportLeadExcel";
import EnrollForm from "../components/admin/EnrollForm";
import EditProfile from "../components/common/EditProfile";
import ShortlistingTable from "../components/admin/application/ShortlistingTable";
import LeadsReport from "../components/admin/reports/LeadsReport";
import RevenueReports from "../components/admin/reports/RevenueReports";
import InvoiceReports from "../components/admin/reports/InvoiceReports";
import ReportsContainer from "../components/admin/reports/ReportsContainer";
import EditProfileStudent from "../components/common/EditProfileStudent";
import StudentMain from "../pages/student/Main";
import ShortListingUniversityForm from "../components/student/student_appication_process/ShortListingUniversityForm.jsx";
import LeadsDataPage from "../components/admin/reports/LeadsDataPage.jsx";
import StaticForm from "../components/student/student_appication_process/StaticForm.jsx";
import MainForex from "../components/student/accomodation/MainForex.jsx";
import { useSelector } from "react-redux";
import ApplicationData from "../components/admin/application-data/ApplicationData.jsx";
import FinalizedApplication from "../components/admin/application/FinalizedApplication.jsx";
import UG from "../components/student/student_appication_process/UG.jsx";

const routes = [
  // {
  //   path: "/",
  //   roles: ["admin", "student", "superadmin"],
  //   element: (
  //     <Navigate to={window.location.pathname || "/student/status"} replace />
  //   ),
  // },
  {
    path: "/student",
    element: <StudentMain />,
    roles: ["student"],
    children: [
      {
        element: <Navigate to="/student/status" replace />,
        // element: <Main />,
        roles: ["student"],
        index: true,
      },
      {
        path: "status",
        element: <StatusComponent />,
        roles: ["student"],
      },
      {
        path: "edit-profile", // Use relative path (no leading slash)
        element: <EditProfileStudent />,
        roles: ["student"],
      },
      {
        path: "finalized-application", // Use relative path (no leading slash)
        element: <FinalizedApplication />,
        roles: ["student"],
      },
      {
        path: "documents_upload",
        element: <StudentApplicationProcess />,
        roles: ["student"],
        children: [
          {
            path: "cv_upload", // This makes the path "/documents_upload/cv_upload"
            element: <CVUpload />,
            roles: ["student"],
          },
          {
            path: "shortlisting_of_universities", // This makes the path "/documents_upload/transcript_upload"
            element: <ShortListingUniversity />,
            roles: ["student"],
          },
          {
            path: "sop", // This makes the path "/documents_upload/transcript_upload"
            element: <SOP />,
            roles: ["student"],
          },
          {
            path: "lor", // This makes the path "/documents_upload/transcript_upload"
            element: <LOR />,
            roles: ["student"],
          },
          {
            path: "ug_only", // This makes the path "/documents_upload/transcript_upload"
            element: <UG />,
            roles: ["student"],
          },
          {
            path: "university_specific_sop", // This makes the path "/documents_upload/transcript_upload"
            element: <UniversitySpecificSOP />,
            roles: ["student"],
          },
          {
            path: "final_documents_upload", // This makes the path "/documents_upload/transcript_upload"
            element: <FinalDocumentUpload />,
            roles: ["student"],
          },
        ],
      },
      {
        path: "university_application_process",
        element: <UniversityApplicationProcess />,
        roles: ["student", "superadmin", "admin"],
        children: [
          {
            path: "",
            element: <ShortlistedTable activeTab={"finalizedUniversity"} />,
            roles: ["student", "superadmin", "admin"],
          },
        ],
      },
      {
        path: "next_step_after_admit",
        element: <AfterAdmit />,
        roles: ["student"],
      },
      {
        path: "visa_process",
        element: <VisaProcess />,
        roles: ["student", "admin", "superadmin"],
      },
      {
        path: "resources",
        element: <StudentResources />,
        roles: ["student"],
      },
      {
        path: "accomodations",
        element: <Accomodations />,
        roles: ["student"],
      },
      {
        path: "mainForex", // Parent path
        element: <MainForex />, // Assuming you have a layout component for the student section
        children: [
          {
            path: ":type", // Relative path (resolves to /student/:type)
            element: <ForexCard />,
            roles: ["student"],
          },
        ],
      },
      // {
      //   path: "forex",
      //   element: <ForexCard />,
      //   roles: ["student"],
      // },
      // {
      //   path: "education-loan",
      //   element: <Forex_cards />,
      //   roles: ["student"],
      // },
      {
        path: "accomodation",
        element: <Accomodation />,
        roles: ["student"],
      },
      // {
      //   path: "insurance",
      //   element: <Forex_cards />,
      //   roles: ["student"],
      // },
    ],
  },

  {
    path: "/admin",
    element: <Main />,

    roles: ["superadmin", "admin"],
    children: [
      {
        index: true,
        element: <Navigate to={"/admin/dashboard"} />,
        roles: ["superadmin", "admin"],
      },
      {
        path: "edit-profile", // Use relative path (no leading slash)
        element: <EditProfile />,
        roles: ["superadmin", "admin"],
      },
      {
        path: "dashboard",
        element: <Dashboard />,
        roles: ["superadmin", "admin"],
      },
      {
        path: "dataTable",
        element: <ApplicationData />,
        roles: ["superadmin", "admin"],
      },
      {
        path: "application",
        element: <Application />,
        roles: ["superadmin", "admin"],
        children: [
          {
            path: "student/:studentId",
            element: <StudentApplication />,
            roles: ["student", "superadmin", "admin"],
          },
          {
            path: "shortlisting/:studentId",
            element: <ShortlistingTable />,
            roles: ["student", "superadmin", "admin"],
          },
          {
            path: "shortlisting/student/:studentId",
            element: <StaticForm />,
            roles: ["student", "superadmin", "admin"],
          },
          {
            path: "status/student/:studentId",
            element: <StatusComponent />,
            roles: ["student", "superadmin", "admin"],
          },
        ],
      },

      {
        path: "leads",
        element: <Leads />,
        roles: ["superadmin", "admin"],
      },
      {
        path: "leads/:id",
        element: <Leads />,
        roles: ["superadmin", "admin"],
      },
      {
        path: "import-leads",
        element: <ImportLeadExcel />,
        roles: ["superadmin", "admin"],
      },
      {
        path: "invoices",
        element: <Invoice />,
        roles: ["superadmin", "admin"],
      },
      // {
      //   path: "profile",
      //   element: <CustomerProfile />,
      //   roles: ["student", "superadmin", "admin"],
      // },

      {
        path: "customers",
        element: <Customer />,
        roles: ["superadmin", "admin"],
        children: [
          {
            path: ":id", // Child route
            element: <CustomerProfile />, // Render the CustomerProfile component
            roles: ["superadmin", "admin"],
          },
        ],
      },
      {
        path: "tools",
        element: <Tool />,
        roles: ["superadmin", "admin"],
        children: [
          // {
          //   path: "services&pricing", // Child route
          //   element: <ServicingAndPricing />, // Render the CustomerProfile component
          //   roles: ["superadmin", "admin"],
          // },
          {
            index: true,
            // FIX: Changed the redirect path to be absolute
            element: <Navigate to="/admin/tools/services&pricing" replace />,
            roles: ["superadmin", "admin"],
          },
          {
            path: "services&pricing", // Child route
            element: <ServicesTabs />, // Render the CustomerProfile component
            roles: ["superadmin", "admin"],
          },
          {
            path: "assigner", // Child route
            element: <RoleAssigner />, // Render the CustomerProfile component
            roles: ["superadmin"],
          },
        ],
      },

      {
        path: "communications",
        element: <Communication />,
        roles: ["superadmin", "admin"],
        children: [
          {
            path: "home",
            element: <Home />,
            roles: ["superadmin", "admin"],
          },
          {
            path: "contacts",
            element: <Contacts />,
            roles: ["superadmin", "admin"],
          },
          {
            path: "campaigns",
            element: <Campaigns />,
            roles: ["superadmin", "admin"],
          },
          {
            path: "report",
            element: <Reports />,
            roles: ["superadmin", "admin"],
          },
        ],
      },
      {
        path: "data-table",
        element: <LeadsDataPage />,
        roles: ["superadmin", "admin"],
      },
      {
        path: "postServices",
        element: <PostServices />,
        roles: ["superadmin", "admin"],
        children: [
          {
            path: "careercounciling",
            element: <CareerCounciling />,
            roles: ["superadmin", "admin"],
            children: [
              {
                path: "manage-preloaded-details",
                element: <ManagePreloadedDetails />,
                roles: ["superadmin", "admin"],
              },
            ],
          },
          {
            path: "profileBuilding",
            element: <ProfileBuilding />,
            roles: ["superadmin", "admin"],
          },
        ],
      },

      // {
      //   path: "profileBuilding",
      //   element: <ProfileBuilding />,
      //   roles: ["student", "superadmin", "admin"],
      // },
      {
        path: "resources",
        element: <Resources />,
        roles: ["superadmin", "admin"],
      },
      {
        path: "reports",
        element: <ReportsContainer />,
        roles: ["superadmin", "admin"],
        children: [
          {
            path: "leads-reports",
            element: <LeadsReport />,
            roles: ["superadmin", "admin"],
          },
          {
            path: "revenue-reports",
            element: <RevenueReports />,
            roles: ["superadmin", "admin"],
          },
          {
            path: "invoice-reports",
            element: <InvoiceReports />,
            roles: ["superadmin", "admin"],
          },
        ],
      },
      {
        path: "leave-wfh",
        element: <Leave />,
        roles: ["superadmin", "admin"],
      },
      {
        path: "manage-preloaded-details",
        element: <ManagePreloadedDetails />,
        roles: ["superadmin", "admin"],
      },
      // {
      //   path: "application/student/:studentId",
      //   element: <StudentDetails />,
      //   roles: ["student", "superadmin", "admin"],
      //   index: true,
      // },
      // {
      //   path: "application/student",
      //   element: <StudentDetails />,
      //   roles: ["student", "superadmin", "admin"],
      //   index: true,
      // },
    ],
  },
];

const renderRoutes = (routes) => {
  return routes.map((route) => {
    const { path, element, roles, index, children } = route;

    // Wrap the element with RequireAuth and Layout if needed
    const RouteElement = roles ? (
      <RequireAuth roles={roles}>{element}</RequireAuth>
    ) : (
      element
    );

    if (children) {
      // For routes with children, create a parent Route and nest child Routes
      return index ? (
        <Route key={path || "index"} index element={RouteElement}>
          {children.map((childRoute) => renderRoutes([childRoute]))}
        </Route>
      ) : (
        <Route key={path} path={path} element={RouteElement}>
          {children.map((childRoute) => renderRoutes([childRoute]))}
        </Route>
      );
    }

    // For routes without children, just return a simple Route
    return index ? (
      <Route key={path || "index"} index element={RouteElement} />
    ) : (
      <Route key={path} path={path} element={RouteElement} />
    );
  });
};

const Router = () => {
  const userRole = useSelector((state) => state.user.role);
  const redirectBasedOnRole = () => {
    switch (userRole) {
      case "student":
        return "/student/status";
      case "admin":
      case "superadmin":
        return "/admin/dashboard";
      default:
        return "/login";
    }
  };
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route
          path="/login"
          element={
            // <AuthRoute>
            <Login />
            // </AuthRoute>
          }
        />
        <Route
          path="/"
          element={<Navigate to={redirectBasedOnRole()} replace />}
        />
        <Route path="/lead-form/:id" element={<LeadForm />} />
        <Route path="/enroll/:id" element={<EnrollForm />} />
        <Route path="/profile-building/:id" element={<ProfileBuilding />} />
        {routes.map(({ path, element, roles, index, children }) => {
          const RouteElement = (
            <RequireAuth roles={roles}>
              <Layout>{element}</Layout>
            </RequireAuth>
          );
          if (children) {
            return (
              <Route
                key={path}
                path={path}
                element={RouteElement}
                index={index}
              >
                {renderRoutes(children)}
              </Route>
            );
          }
          return (
            <Route
              key={path}
              path={path}
              element={RouteElement}
              index={index}
            />
          );
        })}
        <Route path="/psychometric" element={<PsychoHome />}>
          <Route index element={<Content />} />
          <Route path="about" element={<About />} />
          <Route path="questions" element={<Questions />} />
          <Route path="submit" element={<SubmitForm />} />
          <Route path="table" element={<Table />} />
          <Route path="thankyou" element={<Content />} />
        </Route>
        <Route path="/not-authorized" element={<NotAuthorized />} />
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
